// <head> metadata for DbosUserGroupMeetingPage (https://www.dbos.dev/dbos-user-group-meeting).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'DBOS User Group Meeting',
    },
    {
      name: 'description',
      content: 'Thursday March 6 - come connect with DBOS engineering team and other DBOS users.',
    },
    {
      property: 'og:title',
      content: 'DBOS User Group Meeting',
    },
    {
      property: 'og:description',
      content: 'Thursday March 6 - come connect with DBOS engineering team and other DBOS users.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/67bead78e940c615ca507815_DBOS-User-Group-Meeting.png',
    },
    {
      name: 'twitter:title',
      content: 'DBOS User Group Meeting',
    },
    {
      name: 'twitter:description',
      content: 'Thursday March 6 - come connect with DBOS engineering team and other DBOS users.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/67bead78e940c615ca507815_DBOS-User-Group-Meeting.png',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/dbos-user-group-meeting',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
